module.exports = __webpack_public_path__ + "static/absolute_0-f195284070e9ea2fd20a9a0facf5fcd3.jpg";